import './styles.css'

export function StoresPage(): JSX.Element {
    return (
		<div>Stores</div>
	)
}
